export class Playlist {
    constructor({id, name, description, tags, enabled, scheduled, startDate, endDate, targeting, targets, items, itemsObjects, createdAt, updatedAt}) {
        this.version = '2.0';
        this.id = id;
        this.name = name;
        this.description = description;
        this.tags = tags;
        this.enabled = enabled;
        this.scheduled = scheduled;
        this.startDate = startDate;
        this.endDate = endDate;
        this.targeting = targeting;
        this.targets = targets;
        this.items = items;
        this.itemsObjects = itemsObjects;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    };

    clone() {
        return new Playlist({
            id: this.id,
            name: this.name,
            description: this.description,
            tags: this.tags,
            enabled: this.enabled,
            scheduled: this.scheduled,
            startDate: this.startDate,
            endDate: this.endDate,
            targeting: this.targeting,
            targets: this.targets,
            items: this.items.map(item => item.clone()),
            itemsObjects: this.itemsObjects.map(item => item.clone()),
            createdAt: this.createdAt,
            updatedAt: this.updatedAt
        });
    };
};

export const playlistConverter = {
    toFirestore() {
        return null;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        return new Playlist({
            id: snapshot.id,
            name: data.name,
            description: data.description || null,
            tags: data.tags || [],
            enabled: data.enabled || false,
            scheduled: data.scheduled || false,
            startDate: data.start_date || null,
            endDate: data.end_date || null,
            targeting: data.targeting,
            targets: data.targets || [],
            items: data.items ? data.items.map((itemData) => new Item({
                id: itemData.id,
                type: itemData.type,
                priority: itemData.priority
            })) : [],
            itemsObjects: [],
            createdAt: data.created_at,
            updatedAt: data.updated_at
        });
    }
};

export class Item {
    constructor({id, type, priority}) {
        this.id = id;
        this.type = type;
        this.priority = priority;
    };

    clone() {
        return new Item({
            id: this.id,
            type: this.type,
            priority: this.priority
        });
    };
};